"use strict";var ddSdk_1=require("./lib/ddSdk"),otherApi=require("./lib/otherApi"),core=Object.assign({},otherApi,ddSdk_1.ddSdk.getExportSdk());module.exports=core;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/core.js
// module id = 1130
// module chunks = 106